import { routePaths } from './route-paths';
import { IncomeSlipsFormsId } from './common';

export const slipType = {
  income: 'income',
  rrsp: 'rrsp',
  deduction: 'deduction',
};
export const slipTypesData = {
  income: [
    {
      key: routePaths.t4aStatementOfPension,
      label: 'T4A Statement of Pension, Retirement, Annuity and other Income',
      formId: IncomeSlipsFormsId.t4APension,
    },
    {
      key: routePaths.t4StatementOfRemuneration,
      label: 'T4 Statement of Remuneration Paid',
      formId: IncomeSlipsFormsId.t4Enumeration,
    },
    {
      key: routePaths.t3StatementOfTrust,
      label: 'T3 Statement of Trust Income Allocation and Designation',
      formId: IncomeSlipsFormsId.t3TrustIncomeTax,
    },
    {
      key: routePaths.t4psStatementOfEmployeeProfit,
      label:
        'T4PS Statement of Employee Profit Sharing Plan Allocation and Payment',
      formId: IncomeSlipsFormsId.t4PsIncome,
    },
    {
      key: routePaths.t4rifRegisteredRetirement,
      label: 'T4RIF Income from a Registered Retirement Income Fund',
      formId: IncomeSlipsFormsId.t4RifTax,
    },
    {
      key: routePaths.t4rspRrspIncome,
      label: 'T4RSP Income from a RRSP',
      formId: IncomeSlipsFormsId.t4RspIncome,
    },
    {
      key: routePaths.t5StatementOfInvestment,
      label: 'T5 Statement of Investment Income',
      formId: IncomeSlipsFormsId.t5Investment,
    },
    {
      key: routePaths.t5008StatementOfSecurities,
      label: 'T5008 Statement of Securities Transactions',
      formId: IncomeSlipsFormsId.t5008Securities,
    },
    {
      key: routePaths.t4aOasOldAgeSecurity,
      label: 'T4A(OAS) - Old Age Security',
      formId: IncomeSlipsFormsId.t4aOasSecurity,
    },
    {
      key: routePaths.t4apCppQppBenefits,
      label: 'T4A(P) - CPP and QPP Benefits',
      formId: IncomeSlipsFormsId.t4ApCppQpp,
    },
    {
      key: routePaths.t4eBenefits,
      label: 'T4E - Employment Insurance Benefits',
      formId: IncomeSlipsFormsId.t4eBenefits,
    },
    {
      key: routePaths.rc210Cwb,
      label: 'RC210 - CWB Advance Payments',
      formId: IncomeSlipsFormsId.rc210Cwb,
    },
    {
      key: routePaths.t5007Benefits,
      label: 'T5007 - Statement of Benefits',
      formId: IncomeSlipsFormsId.t5007Benefits,
    },
    {
      key: routePaths.rc62UCCB,
      label: 'RC62 - Universal Child Care Benefit',
      formId: IncomeSlipsFormsId.rc62UCCB,
    },
    {
      key: routePaths.t4arcaArrangement,
      label: 'T4A - RCA - Distributions from a Retirement Compensation Arrangement',
      formId: IncomeSlipsFormsId.t4arcaArrangement,
    },
    {
      key: routePaths.T5006RegisteredLabour,
      label: 'T5006 - Registered Labour-Sponsored Venture Capital Corporation Shares ',
      formId: IncomeSlipsFormsId.T5006RegisteredLabour,
    },
    {
      key: routePaths.foreignIncome,
      label: 'Foreign Income',
      formId: IncomeSlipsFormsId.foreignIncome,
    },
    {
      key: routePaths.t10PensionAdjustment,
      label: 'T10  - Pension Adjustment',
      formId: IncomeSlipsFormsId.t10PensionAdjustment,
    },
    // {
    //   key: routePaths.selfEmploymentIncome,
    //   label: 'self employment income',
    //   formId: IncomeSlipsFormsId.selfEmploymentIncome,
    // },
    // {
    //   key: routePaths.t1139Form,
    //   label: 'self employment income',
    //   formId: IncomeSlipsFormsId.t1139Form,
    // },
    // {
    //   key: routePaths.selfBusinessIncome,
    //   label: 'self employment income',
    //   formId: IncomeSlipsFormsId.selfBusinessIncome,
    // },
    // {
    //   key: routePaths.businessIncome,
    //   label: 'Business income',
    //   formId: IncomeSlipsFormsId.businessIncome,
    // },
    // {
    //   key: routePaths.businessVehicleExpenses,
    //   label: 'Business vehicle expenses',
    //   formId: IncomeSlipsFormsId.businessVehicleExpenses,
    // },
    // {
    //   key: routePaths.personalVehicleExpenses,
    //   label: 'Business vehicle expenses',
    //   formId: IncomeSlipsFormsId.personalVehicleExpenses,
    // },
    // {
    //   key: routePaths.advertising,
    //   label: 'Advertising',
    //   formId: IncomeSlipsFormsId.advertising,
    // },
    // {
    //   key: routePaths.entertainment,
    //   label: 'Entertainment',
    //   formId: IncomeSlipsFormsId.entertainment,
    // },
    // {
    //   key: routePaths.wages,
    //   label: 'Wages',
    //   formId: IncomeSlipsFormsId.wages,
    // },
    // {
    //   key: routePaths.businessRelated,
    //   label: 'Business Related',
    //   formId: IncomeSlipsFormsId.businessRelated,
    // },
    // {
    //   key: routePaths.doubtfulAccount,
    //   label: 'Doubtful Account',
    //   formId: IncomeSlipsFormsId.doubtfulAccount,
    // },
    {
      key: routePaths.licensesTaxes,
      label: 'Licenses Taxes',
      formId: IncomeSlipsFormsId.licensesTaxes,
    }, {
      key: routePaths.commercialInsurance,
      label: 'Commercial Insurance',
      formId: IncomeSlipsFormsId.commercialInsurance,
    },
  ],
};
export const slipFormRoutes = {
  [slipType.income]: {
    [IncomeSlipsFormsId.t4APension]: routePaths.t4aStatementOfPension,
    [IncomeSlipsFormsId.t4Enumeration]: routePaths.t4StatementOfRemuneration,
    [IncomeSlipsFormsId.t3TrustIncomeTax]: routePaths.t3StatementOfTrust,
    [IncomeSlipsFormsId.t4PsIncome]: routePaths.t4psStatementOfEmployeeProfit,
    [IncomeSlipsFormsId.t4RifTax]: routePaths.t4rifRegisteredRetirement,
    [IncomeSlipsFormsId.t4RspIncome]: routePaths.t4rspRrspIncome,
    [IncomeSlipsFormsId.t5Investment]: routePaths.t5StatementOfInvestment,
    [IncomeSlipsFormsId.t5008Securities]: routePaths.t5008StatementOfSecurities,
    [IncomeSlipsFormsId.t4aOasSecurity]: routePaths.t4aOasOldAgeSecurity,
    [IncomeSlipsFormsId.t4ApCppQpp]: routePaths.t4apCppQppBenefits,
    [IncomeSlipsFormsId.t4eBenefits]: routePaths.t4eBenefits,
    [IncomeSlipsFormsId.rc210Cwb]: routePaths.rc210Cwb,
    [IncomeSlipsFormsId.t5007Benefits]: routePaths.t5007Benefits,
    [IncomeSlipsFormsId.rc62UCCB]: routePaths.rc62UCCB,
    [IncomeSlipsFormsId.t4arcaArrangement]: routePaths.t4arcaArrangement,
    [IncomeSlipsFormsId.T5006RegisteredLabour]: routePaths.T5006RegisteredLabour,
    [IncomeSlipsFormsId.foreignIncome]: routePaths.foreignIncome,
    [IncomeSlipsFormsId.t10PensionAdjustment]: routePaths.t10PensionAdjustment,
    // [IncomeSlipsFormsId.selfEmploymentIncome]: routePaths.selfEmploymentIncome,
    // [IncomeSlipsFormsId.t1139Form]: routePaths.t1139Form,
    // [IncomeSlipsFormsId.selfBusinessIncome]: routePaths.selfBusinessIncome,
    // [IncomeSlipsFormsId.businessIncome]: routePaths.businessIncome,
    // [IncomeSlipsFormsId.businessVehicleExpenses]: routePaths.businessVehicleExpenses,
    // [IncomeSlipsFormsId.personalVehicleExpenses]: routePaths.personalVehicleExpenses,

    // [IncomeSlipsFormsId.advertising]: routePaths.advertising,
    // [IncomeSlipsFormsId.entertainment]: routePaths.entertainment,
    // [IncomeSlipsFormsId.wages]: routePaths.wages,
    // [IncomeSlipsFormsId.businessRelated]: routePaths.businessRelated,

    // [IncomeSlipsFormsId.doubtfulAccount]: routePaths.doubtfulAccount,
  },
  [slipType.rrsp]: {
    [IncomeSlipsFormsId.rrspRetirement]: routePaths.retirementSavingForm,
  },
  [slipType.deduction]: {
    [IncomeSlipsFormsId.t2202Tuition]: routePaths.t2202Tuition,
    [IncomeSlipsFormsId.donationSlip]: routePaths.donationSlipDeduction,
    [IncomeSlipsFormsId.medicalSlip]: routePaths.medicalSlipDeduction,
  },
};
export const tSlipType = {
  t101Slip: 't101Slip',
  t5013Slip: 't5013Slip',
};
